import React from 'react';
import b_ from 'b_';
import cn from 'classnames';
import { toSrcSetString } from '../../global/functions';
import { Tile } from '../Tile';
import { Link } from '../Link';
import './styles.scss';

const b = b_.lock('SupportPublicationsListItem');

export const SupportPublicationsListItem = ({
  className,
  headingTag: Heading = 'h2',
  name,
  path,
  tileImage: image,
  sizes = '(min-width: 640px) 320px, calc(50vw - 20px) 100%',
  previewText
}) => (
  <Tile
    as='article'
    className={cn(b(), className)}
    defaultStyles={false}
  >
    <div className={b('imageWrap')}>
      {image && (
        <img
          alt={name}
          className={b('image')}
          srcSet={toSrcSetString(image)}
          src={image[320]}
          sizes={sizes}
        />
      )}
    </div>
    <div className={b('descriptions')}>
      <Heading className={b('heading')}>
        <Link className={b('link')} to={path}>
          {name}
        </Link>
      </Heading>
      <p className={b('previewText')}>{previewText}</p>
    </div>
  </Tile>
);
